exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-select[data-v-31e73b04]{height:34px!important;border-radius:3px!important;padding:1px 8px}.small-description[data-v-31e73b04]{line-height:11px}.b-group-item-end[data-v-31e73b04]{display:flex!important;justify-content:space-between!important}.b-group-item-end b[data-v-31e73b04]{text-transform:none}", ""]);

// exports
